import React, { useEffect, useState, useContext } from 'react';
import Treeview from '../../../components/generic/Treeview';
import { AirtimePlanningContext } from '../../../contexts/AirtimePlanningContext';
import { getStationCount } from './CampaignStationsUtils';

const StationSelectionTableNew = ({ campaignStations, setSelectedStations, networks, disabled = false }) => {
    const { showInvalidatePlanMessage } = useContext(AirtimePlanningContext);

    const [initialStations, setInitialStations] = useState();
    const [totalStations, setTotalStations] = useState(0);
    const [stationCount, setStationCount] = useState(0);

    useEffect(() => {
        // console.log('campaignstations', campaignStations, 'networks', networks);
        const init = {};
        campaignStations.map((a, b) => {
            init[a.id] = a;
        });
        setInitialStations(init);
        const numStations = initialStations ? Object.keys(initialStations).length : 0;
        updateStationCount(numStations);
        if (initialStations) setStationCount(numStations);
    }, [campaignStations]);

    useEffect(() => {
        updateStationCount(stationCount);
    }, [networks]);

    const updateStationCount = (selectedStations) => {
        setTotalStations(getStationCount(networks) - selectedStations);
    };

    const dochange = (d) => {
        console.log(d);
        setSelectedStations(d);
        setStationCount(d.length);
        updateStationCount(stationCount);

        showInvalidatePlanMessage(null, false);
    };

    return (
        <div style={{ height: 600 }}>
            <Treeview
                items={networks}
                initialSelection={initialStations}
                selectionChange={dochange}
                title={`Select Stations from: (${totalStations})`}
                minRows={20}
                disabled={disabled}
            ></Treeview>
        </div>
    );
};

export default StationSelectionTableNew;
